import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/protected/_layout/warehouse/_layout/')({
  component: () => null,
});
